<template>
  <PageManager
    :iframe-target="pageUrl"
    :page="page"
  >

    <template #before-sidebar>
      <WebsitePages @provide-page="newPage => page = newPage"/>
    </template>

    <template #empty>
      <div class="text-center">
        <svg xmlns="http://www.w3.org/2000/svg" class="mx-auto h-24 w-24 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1">
          <path stroke-linecap="round" stroke-linejoin="round" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
        </svg>
        <h3 class="mt-2 text-2xl font-medium text-gray-900">No page selected</h3>
        <p class="mt-1 text-xl text-gray-500">You can create a new page on the left sidebar.</p>
      </div>
    </template>

  </PageManager>
</template>

<script>

import PageManager from "@/components/SideEditor/PageManager"
import WebsitePages from "@/components/SideEditor/Pages/WebsitePages"

import { mapGetters } from "vuex"

export default {
  components: {
    PageManager,
    WebsitePages,
  },
  data() {
    return {
      page: null,
      pageData: null,
    }
  },
  created() {
    this.$store.dispatch("editor/pushSaveListener", this.savePageConfig)
    this.$store.dispatch("editor/pushConfigLoader", this.loadPageConfiguration)
  },
  beforeDestroy() {
    this.$store.dispatch("editor/removeSaveListener", this.savePageConfig)
    this.$store.dispatch("editor/removeConfigLoader", this.loadPageConfiguration)
    // add back all remove styles
  },
  methods: {
    async loadPageConfiguration() {
      this.pageData = (await this.axios.get(`/api/websites/${this.$route.params.id}/pages/${this.page}`)).data

      try {
        const json = JSON.parse(
          this.pageData.content
            .replace(/\\n /g, "")
            .replace(/\\n/g, "")
        )
        this.$store.commit("editor/currentPage", json.default || json)
      } catch (err) {}
    },
    async savePageConfig() {
      const config = { blocks_collection: {...this.config.blocks_collection} }
      Object.keys(config.blocks_collection).forEach(page => {
        if (page !== this.page) {
          delete config.blocks_collection[page]
        }
      })

      await this.axios.put(`/api/websites/${this.$route.params.id}/pages/${this.page}`, {
        name: this.pageData.name,
        type: this.pageData.type,
        content: JSON.stringify(config, null, 2)
          .replace(/\"/g, '"'),
      })
      this.$store.dispatch('clearCacheSearch', "websites")
    },
  },
  computed: {
    ...mapGetters({
      config: 'editor/config',
      domain: 'editor/fullDomainLink',
    }),

    pageUrl() {
      return `${this.domain}/backoffice-page-configuration`
    },
  },
  watch: {
    page() {
      this.loadPageConfiguration()
    },
  },
}

</script>
